import { validators } from '@vtblife/form-kit';
import { createDependencyValidator } from '@vtblife/form-renderer-kit/dist/components/form-renderer/utils/create-dependency-validator';
import { getStepFieldSettings } from '../../../utils/step-field';
export function getStepValidator(step) {
    const validatorsArray = getValidators(step);
    return validators.pipe(...validatorsArray);
}
function getValidators(step) {
    var _a;
    const fieldSettings = getStepFieldSettings(step);
    const required = (_a = fieldSettings === null || fieldSettings === void 0 ? void 0 : fieldSettings.required) !== null && _a !== void 0 ? _a : true;
    if (step.type === 'rating') {
        if (required) {
            return [notEmptyRating()];
        }
        return [];
    }
    if (step.type === 'select-region') {
        if (required) {
            return [notEmpty({ message: 'Необходимо выбрать город' })];
        }
        return [];
    }
    if (step.type === 'checkbox-group') {
        if (required) {
            return [notEmptyArray({ message: 'Необходимо выбрать вариант' })];
        }
        return [];
    }
    if (required) {
        const dependencyValidator = createDependencyValidator(step.condition);
        return [notEmpty({ dependencyValidator })];
    }
    return [validators.mayBeEmptyString()];
}
function notEmpty({ message = 'Обязательное поле', dependencyValidator, }) {
    return function (value, formData) {
        // Если шаг не был отображен в форме
        if (dependencyValidator && !dependencyValidator(formData)) {
            return;
        }
        if (typeof value !== 'number' && !value) {
            return message;
        }
        if (typeof value === 'string' && value.trim().length === 0) {
            return message;
        }
        return;
    };
}
function notEmptyRating() {
    return function (value) {
        if (!value.rating) {
            return 'Обязательное поле';
        }
        return;
    };
}
export function notEmptyArray({ message = 'Обязательное поле' }) {
    return function (value) {
        if (Array.isArray(value) && value.length === 0) {
            return message;
        }
        if (typeof value === 'string' && value.trim().length === 0) {
            return message;
        }
        return;
    };
}
//# sourceMappingURL=get-step-validator.js.map